const ROLE_READONLY = 'beststart.pathway.readonly';
const ROLE_ADMIN = 'beststart.pathway.admin';
const OPERATIONAL_USER = 'beststart.pathway.operational';
const COMMUNICATION_ADMIN = 'beststart.pathway.communications';
const ALL_CENTRES = 'beststart.pathway.allcentres';
const ROLE_SUPERADMIN = 'beststart.pathway.superadmin';

const ALL_ROLES = [
    ROLE_READONLY,
    OPERATIONAL_USER,
    COMMUNICATION_ADMIN,
    ROLE_ADMIN,
    ROLE_SUPERADMIN,
];

const OPERATIONAL_ROLES = [
    OPERATIONAL_USER,
    ROLE_ADMIN,
    ROLE_SUPERADMIN,
];

const RECORD_SEARCH_ROLES = [
    ROLE_READONLY,
    ...OPERATIONAL_ROLES,
];

const SYSTEM_ADMINS = [
    ROLE_SUPERADMIN,
    ROLE_ADMIN,
];

const TEMPLATE_ROLES = [
    COMMUNICATION_ADMIN,
    ...SYSTEM_ADMINS,
];

const ADMINS = SYSTEM_ADMINS;

const ALL_CENTRE_ROLES = [
    ALL_CENTRES,
    ...SYSTEM_ADMINS,
];

export {
    ROLE_READONLY,
    OPERATIONAL_USER,
    COMMUNICATION_ADMIN,
    ALL_CENTRES,
    ROLE_SUPERADMIN,
    ROLE_ADMIN,
    ALL_ROLES,
    OPERATIONAL_ROLES,
    RECORD_SEARCH_ROLES,
    ADMINS,
    SYSTEM_ADMINS,
    TEMPLATE_ROLES,
    ALL_CENTRE_ROLES,
};

export default {
    ROLE_READONLY,
    OPERATIONAL_USER,
    COMMUNICATION_ADMIN,
    ALL_CENTRES,
    ROLE_SUPERADMIN,
    ROLE_ADMIN,
    ALL_ROLES,
    OPERATIONAL_ROLES,
    RECORD_SEARCH_ROLES,
    ADMINS,
    SYSTEM_ADMINS,
    TEMPLATE_ROLES,
    ALL_CENTRE_ROLES,
};